/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для заказа в списке заказов на странице истории.
   */
  app.OrderItemView = app.View.extend({
    events: {
      'click .js-repeat': 'repeatOrder',
      'touchstart .js-repeat': 'repeatOrder',
      'click .js-goods-ctl': 'fetchOrderItems',
      'click .order-goods-ctl': 'showOrderItems',
      'click .js-goods-more': 'renderOrderItemsMore',
      'click .re-ordering button': 'reorder',
      'click .js-send-email-notification': 'sendEmailNotification',
      'click .js-confirm': 'confirmRequest',
      'click .js-add-request': 'addToOrder',
      'click .js-remove-request': 'removeFromOrder',
      'click .js-show-more-delivery-info': 'showMoreDeliveryInfo',
      'change .js-jp-order-comment-field': 'saveJpOrderComment',
      'input .js-jp-order-comment-field': 'applyResize',
    },
    orderItemsTemplateId: '#order-products',
    orderItemsLimit: 9,
    jpOrders: {},
    additionalOptions: ['faderView', 'bodyView'],

    /**
     * @inheritDoc
     */
    run: function () {
      // статусы, при которых можно добавлять/удалять заявку из заказа
      this.JP_ORDER_STATUSES = [
        app.JpOrder.prototype.JP_ORDER_STATUS_RESERVED,
        app.JpOrder.prototype.JP_ORDER_STATUS_CONFIRMED,
      ];
      var $time = this.$('time');
      var that = this;
      //Вызывается прерывание, чтобы при перерендеривании времени не показывалось NaN
      var timeoutRender = function () {
        $time.countdown(new Date($time.attr('data-date')), function (event) {
          that.$('.days', $time).html(event.strftime('%D'));
          that.$('.hours', $time).html(event.strftime('%H'));
          that.$('.minutes', $time).html(event.strftime('%M'));
          that.$('.seconds', $time).html(event.strftime('%S'));
        });
      };
      setTimeout(timeoutRender, 0);
      this.popup = new als.Popup($('.jp-organizer-info-popup'), $('.js-show-organizer-info'));
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          $('.jp-organizer-info-popup').css({
            position: 'absolute',
            top: 230,
            left: '50%'
          });
        }
      );
      this.initParcelPopup();
      /**
       * Если заказ является заявкой, добавляем попап выбора причина отмены заявки.
       * Только на десктопе
       */
      if (!app.isMobile && this.model.get('is_jp_request')) {
        this.childViews.cancellationPopup = new app.JPOrderCancellationView({
          model: new app.JpOrder({
            id: this.model.id,
          }),
          type: this.model.get('is_jp_organizer') ? 'organizer' : 'participant',
        });

        /**
         * При успешной отмене, перезагружаем страницу
         */
        this.listenTo(this.childViews.cancellationPopup, 'cancellation-popup:success', this.handleSuccessCancel);
      }
      app.helpers.DomHelper.resizeTextarea(this.$('.js-jp-order-comment-field'));

      this.positionDeclinations = app.helpers.TemplateHelper.getJson('#position-declinations-json');
      this.addButtonTemplate = app.helpers.TemplateHelper.getTemplate('#add-button-template');
      this.commentFieldSelector = '.js-jp-order-comment-field';
    },

    /**
     * Инициализация попапа с номером отслеживания доставки посылки.
     */
    initParcelPopup: function() {
      var popup = '.js-parcel-number[data-order-id=' + this.model.get('id') + ']';
      var opener = '.js-link_parcels-opener[data-order-id=' + this.model.get('id') + ']';
      if (!app.isMobile) {
        this.parcelPopup = new als.Popup($(popup), $(opener));
      } else if (typeof app.MobilePopupFillView !== 'undefined' ) {
        this.childViews.popupView = new app.MobilePopupFillView({
          el: $(popup),
          $opener: $(opener),
          bodyView: this.bodyView,
        });
        this.parcelPopup = this.childViews.popupView.popup;
      }
    },

    /**
     * Обновляет шильдик заказа и скрывает кнопку отмены при успешной отмене заявки.
     * @param {app.Model} model Модель заявки СП.
     */
    handleSuccessCancel: function (model) {
      if (model instanceof app.Model && model.get('id') === this.model.get('id')) {
        var statusData = model.get('jp_order_status') || {};
        var $orderFlag = this.$('.js-order-flag');
        var isNewBadgeColors = app.features && app.features.is_new_badge_colors;
        var flagClasses = isNewBadgeColors ? 'flag flag-square' : 'flag';
        $orderFlag
          .attr('class', flagClasses)
          .addClass('flag_' + statusData.color)
          .text(statusData.name);
        this.$('.js-open-cancellation-popup').addClass('not_display');
        this.$('.js-add-request-button').addClass('not_display');
        this.$('.js-confirm-button').addClass('not_display');
      }
    },

    /**
     * Повторение заказа
     * @param {Event} e Событие клика или тач-событие на кнопку 'Повторить заказ'
     */
    repeatOrder: function (e) {
      var isService = this.model && this.model.get('is_service');
      this.repeatButton = $(e && e.currentTarget);

      if (isService) {
        this.repeatServiceOrder();
      } else {
        this.repeatDefault();
      }
    },

    /**
     * Повторение заказа (не услуги).
     */
    repeatDefault: function () {
      var orderId = this.model && this.model.get('id');
      if (orderId) {
        Backbone.trigger('close-cancellation-popup');
        if (this.childViews.confirmRepeatPopupView) {
          this.childViews.confirmRepeatPopupView.show();
        } else {
          this.childViews.confirmRepeatPopupView = new app.ConfirmRepeatPopupView({
            orderId: orderId,
            faderView: this.faderView,
          });
        }
      }
    },

    /**
     * Загружает данные о заказе и товарах в нем
     */
    fetchOrderItems: function () {
      if (this.model.has('items')) {
        var items = this.model.get('items');
        if (_.isArray(items) && items.length && items[0].item_sid) {
          return;
        }
      }
      var that = this;
      // загружаем модель заказа
      $.when(this.model.fetch({data: {expand: 'items,check_items,check_items_count'}}))
        .done(function () {
          that.renderOrderItems();
        });
    },

    /**
     * Показывает товары в заказе
     * @param e - событие клика
     */
    showOrderItems: function (e) {
      var target = $(e.currentTarget);
      var i = target.attr('rel');
      target.toggleClass('active');
      $('.js-goods').filter('[id=' + i + ']').slideToggle(250);
    },

    /**
     * Рендерит список товаров в заказе
     * @param limit Количество отображаемых товаров (0 - вывести все)
     */
    renderOrderItems: function (limit) {
      this.templateOrderItems = app.helpers.TemplateHelper.getTemplate(this.orderItemsTemplateId);
      if (typeof limit === 'undefined') {
        limit = this.orderItemsLimit;
      }
      var items,
        itemsCount,
        checkItems = this.model.get('check_items');
      if (checkItems && checkItems.length) {
        items = checkItems;
        itemsCount = this.model.get('check_items_count');
      } else {
        items = this.model.get('items');
        itemsCount = items.length;
      }
      var morePositionsLength = itemsCount - limit;
      var element = this.templateOrderItems({
        limit: limit,
        items: items,
        morePositionsLength: morePositionsLength,
        positionDeclination: app.helpers.DeclinationHelper.format(morePositionsLength, this.positionDeclinations, app.locale)
      });
      this.$('.js-goods').html(element);
    },

    /**
     * рендерит список всех товаров в заказе
     */
    renderOrderItemsMore: function () {
      app.helpers.RedirectHelper.locationAssign('/order/' + this.model.get('id') + '/');
    },

    /**
     * Добавить дозаказ к данному заказу
     * @param event
     */
    reorder: function (event) {
      var button = this.$(event.currentTarget),
        id = button.data('id');
      if (id) {
        (new app.Order()).reorder(id, {
          success: function (model) {
            if (model.get('id')) {
              app.helpers.OkoHelper.awaitPush({
                'n': 'order',
                'sum': parseFloat(model.get('total')),
                'id': parseInt(model.id, 10),
                'type_id': model.get('jp_requests') ? app.ORDER_TYPE_ID.jpOrganizer : app.ORDER_TYPE_ID.default
              },
              function () {
                app.helpers.RedirectHelper.locationAssign('/order/done/' + model.get('id') + '/');
              });
            }
          }
        });
      }
    },

    /**
     * Запрашивает данные о товаре и триггерит событие для вызова попапа заказа услуги с данными о товаре
     */
    repeatServiceOrder: function () {
      if (this.serviceItem) {
        Backbone.trigger('service-checkout:proceed', this.serviceItem);
      } else {
        if (this.repeatButton){
          this.disableElement(this.repeatButton);
        }
        this.listenToOnce(this.model, 'sync', this.fetchServiceItem.bind(this));
        this.model.fetch();
      }
    },

    /**
     * Заполнение коллекции и получение результата.
     * @param {Model} order Информация о заказе.
     */
    fetchServiceItem: function (order) {
      var orderItem = order && order.get('items') && order.get('items')[0];
      if (orderItem){
        var serviceItem = new app.Item({
          id: orderItem.item_id,
          qty: orderItem.qty
        });
        serviceItem.urlRoot = app.entryScriptName + '/api/v3/item/';
        this.serviceItem = serviceItem;

        this.listenToOnce(serviceItem, 'sync', function () {
            Backbone.trigger('service-checkout:proceed', serviceItem);
            this.enableElement(this.repeatButton);
          }.bind(this));
        this.listenToOnce(serviceItem, 'error', function () {
            this.enableElement(this.repeatButton);
          }.bind(this));
        serviceItem.fetch();
      } else {
        app.helpers.ErrorHelper.globalValidationError([{
          message: 'Нет товаров в заказе',
        }], 'При повторе заказа-услуги');
      }
    },

    /**
     * Отправка запроса на смену статуса email_send_status_id у заказа.
     * @param e
     */
    sendEmailNotification: function (e) {
      var button = e.currentTarget,
        orderId = button.dataset.orderId,
        orderData = {
          email_send_status_id: 2,
          id: orderId
        },
        options = {
          success: function () {
            // Скрываем текст о возможности отправки, показываем текст, что письма отправлены
            $('.js-send-email-text-before').addClass('not_display');
            $('.js-send-email-text-after').removeClass('not_display');
          },
          error: function (model, xhr) {
            app.helpers.ErrorHelper.globalValidationError([{
              message: xhr.responseJSON.message
            }], 'При попытке отправки оповещения участникам совместной покупки');
          }
        },
        order = new app.Order();

      $(button).attr('disabled', true);
      order.url = '/api/v3/jp-order/'+ orderId;
      order.save(orderData, options);
    },

    /**
     * Модель заявки.
     * @param orderId
     * @returns {*}
     */
    getJpOrderModel: function (orderId) {
      if (typeof this.jpOrders[orderId] == 'undefined') {
        this.jpOrders[orderId] = new app.JpOrder({id: orderId});
      }
      return this.jpOrders[orderId];
    },

    /**
     * Сохранение комментария к заявке.
     * @param e
     */
    saveJpOrderComment: function (e) {
      var $field = $(e.currentTarget),
        orderId = $field.data('id'),
        comment = $field.val(),
        model = this.getJpOrderModel(orderId);
      model.save({
        comment: comment,
      }, {
        success: this.onSuccessfulChangeComment.bind(this),
        error: this.onFailedChangeComment.bind(this),
      });
      if (comment) {
        $field.addClass('large');
      } else {
        $field.removeClass('large');
      }
    },

    /**
     * Обрабатывает успешное сохранение формы
     */
    onSuccessfulChangeComment: function () {
      this.$(this.commentFieldSelector).removeClass('error');
      this.$(this.commentFieldSelector + '-error').addClass('not_display');
    },

    /**
     * Обрабатывает ошибку сохранения формы
     */
    onFailedChangeComment: function () {
      this.$(this.commentFieldSelector).addClass('error');
      this.$(this.commentFieldSelector + '-error').removeClass('not_display');
    },

    /**
     * Подтверждение заявки.
     * Отправляет запрос на изменение статуса на "Подтверждено организатором"
     * @param {Event} e
     */
    confirmRequest: function (e) {
      var model = this.getJpOrderModel(this.model.get('id'));

      this.listenToOnce(model, 'sync', function () {
        if (app.preloader) {
          app.preloader.remove();
        }
        this.showConfirmedStatus();
      });
      this.disableButton(e);

      model.save({
        jp_order_status_id: model.JP_ORDER_STATUS_CONFIRMED
      });
    },

    /**
     * Сменить текст статуса
     */
    showConfirmedStatus: function () {
      var text = app.helpers.TemplateHelper.getTemplate('#order-status-confirmed-template')();
      this.$('.js-order-flag').html(text);
    },

    /**
     * Обработка события "input" на текстовой области
     * @param {Event} e
     */
    applyResize: function (e) {
      var $el = $(e.currentTarget);
      app.helpers.DomHelper.resizeTextarea($el);
    },

    /**
     * Получить модель закупки. Создается при первом обращении.
     * @returns {app.JointPurchase} Модель закупки
     */
    getJpPurchase: function () {
      if (!this.jpPurchase) {
        var jpPurchaseData = this.model.get('jp_purchase');
        var jpPurchase = new app.JointPurchase({
          id: jpPurchaseData.id
        });
        jpPurchase.selectedOrders = jpPurchaseData.jp_purchase_selected_orders;
        this.jpPurchase = jpPurchase;
      }
      return this.jpPurchase;
    },

    /**
     * Добавить заявку к заказу
     * @param {Event} e
     */
    addToOrder: function (e) {
      var id = this.model.get('id');

      this.disableButton(e);
      this.waitForPurchaseSync(true);
      this.getJpPurchase().addRequestToOrder(id);
    },

    /**
     * Удалить заявку из заказа
     * @param {Event} e
     */
    removeFromOrder: function (e) {
      var id = this.model.get('id');

      this.disableButton(e);
      this.waitForPurchaseSync(false);
      this.getJpPurchase().removeRequestFromOrder(id);
    },

    /**
     * Перерисовать кнопку добавления/удаления заявки
     * @param {Boolean} isAdded добавлена ли заявка
     */
    rerenderAddButton: function (isAdded) {
      this.$('.js-add-button-block').html(this.addButtonTemplate({
        addedToOrder: isAdded,
        canAddOrRemove: _.includes(this.JP_ORDER_STATUSES, this.model.get('jp_order').jp_order_status_id),
      }));
    },

    /**
     * Отключает кнопку и показывает прелоадер
     * @param {Event} e Событие клика
     */
    disableButton: function (e) {
      var button = $(e.currentTarget);
      this.disableElement(button);
      if (app.preloader) {
        app.preloader.render();
      }
    },

    /**
     * Делает элемент недоступным.
     * @param {jQuery} $el Элемент
     */
    disableElement: function ($el) {
      if ($el instanceof $) {
        $el.attr('disabled', true);
      }
    },

    /**
     * Делает елемент доступным
     * @param {jQuery} $el Элемент
     */
    enableElement: function ($el) {
      if ($el instanceof $) {
        $el.attr('disabled', false);
      }
    },

    /**
     * Ожидание синхронизации модели закупки.
     * После успешной синхронизации удаляет прелоадер и перерисовывает кнопку
     * @param isAdded
     */
    waitForPurchaseSync: function (isAdded) {
      this.listenToOnce(this.getJpPurchase(), 'sync', function () {
        this.rerenderAddButton(isAdded);
        if (app.preloader) {
          app.preloader.remove();
        }
      });
    },

    /**
     * Показать блок со списком стоимости доставки.
     */
    showMoreDeliveryInfo: function () {
      this.$('.js-delivery-parts-list').removeClass('not_display');
      this.$('.js-more-delivery-link-wrapper').addClass('not_display');
    },
  });
})();

}.call(window));